import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/constants";

export default function WhatsAppFloat() {
  return (
    <a
      href={waLink("Bonjour MaxiChoix ! Je souhaite passer une commande.")}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      data-testid="whatsapp-float"
      aria-label="Contacter sur WhatsApp"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <MessageCircle size={26} className="relative" />
    </a>
  );
}
